<template>
  <draggable
    v-model="items"
    handle=".draggable"
    tag="ul"
    @end="dragEnd(items)"
  >
    <component
      :is="resolveNavItemComponent(item)"
      v-for="item in items"
      :key="item.id"
      :item="item"
    />
  </draggable>

</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent, createMenu, refreshMenu } from '@core/layouts/utils'
import { provide, ref } from '@vue/composition-api'
import draggable from 'vuedraggable'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
    draggable,
  },
  data() {
    return {
      items: [],
      newItemParentId: null,
    }
  },
  async created() {
    await this.getMenu()
  },
  mounted() {
    this.$root.$on('refreshMenu', (goFirstPage = false) => {
      this.reinitMenu(goFirstPage)
    })
    this.$root.$on('dragEnd', items => {
      this.dragEnd(items)
    })
  },
  beforeDestroy() {
    this.$root.$off('refreshMenu')
    this.$root.$off('dragEnd')
  },
  methods: {
    dragEnd(items) {
      const orderedList = items.map(x => x.id)
      useJwt.axiosIns.post('page/reorderpages', { StringValue: orderedList.join(',') })
        .then(() => {
        })
        .catch(e => {
          console.log(e)
        })
    },
    async getMenu() {
      await createMenu()
      this.items = this.$store.state.verticalMenu.menuLinks.filter(m => !m.userId)
    },
    async reinitMenu(goFirstPage = false) {
      await refreshMenu()
      this.items = this.$store.state.verticalMenu.menuLinks.filter(m => !m.userId)
      if (goFirstPage) {
        this.$router.push({ name: 'dashboard', params: { id: this.items[0].id } })
      }
    },
  },
  setup() {
    provide('openGroups', ref([]))

    return {
      resolveNavItemComponent,
    }
  },
}
</script>
